import {useMaterialWithRecipes} from '@domain/materials'
import {useIsMutating} from '@tanstack/react-query'

import {useUrlParam} from '../../../routing'

export const useMaterialWithRecipesQuery = (materialId?: number) => {
  const plantCode = useUrlParam('plantCode')
  // work around to disable fetching material details when it's already deleted
  const mutating = useIsMutating({mutationKey: ['materials']})
  const isMutating = Boolean(mutating)
  return useMaterialWithRecipes({
    plantCode,
    materialId,
    options: {
      enabled: materialId !== undefined && !isMutating
    }
  })
}
